import type { ConfigProviderProps } from 'antd/es/config-provider';

import { css } from 'config/emotionCss';

const rootStyle = css`
  .ant-checkbox-disabled + span {
    color: inherit;
  }

  &.ant-checkbox-wrapper {
    &.block {
      width: 100%;
      display: flex;

      > .ant-checkbox + span {
        width: 100%;
      }
    }
  }
`;

/* Here rather than in the wrapper: the label leading has to reach the call sites that import
   Checkbox straight from antd -- the user role cards are 20 of the 22 checkboxes on one screen --
   and CheckboxCards, whose own layout only objected to the flex row, not to the leading.
   The Checkbox lineHeight token is Figma's "Label/Small" 14/16 and sizes the box row; several
   labels in the app are a title plus a wrapping description, which 16px crowds. */
const labelStyle = css`
  line-height: 20px;
`;

const checkboxConfig: ConfigProviderProps['checkbox'] = {
  classNames: { root: rootStyle, label: labelStyle },
};

export default checkboxConfig;
